<template>
  <div id="bu-dealer-brands" :class="$style.brands">
    <template v-for="brand in brandsWithLogoData">
      <RawHtml :key="brand[c.ID]" :template="brand[c.LOGO_DATA]" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep, get, has } from 'lodash-es'
import { getDataArray } from '@/js/helper/relationships-helper.js'

import API_CONSTANTS from '@/js/helper/api-constants.js'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import BRANDS_ACTIONS from '@/js/plugins/store/modules/brands/actions-types.js'
import BRANDS_GETTERS from '@/js/plugins/store/modules/brands/getter-types.js'
import BRAND_CONSTANTS from '@/js/plugins/store/modules/brands/brands-constants'

import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'

import RawHtml from '@/js/components/Shared/RawHtml.js'

export default {
  name: 'BuDealerBrands',
  components: { RawHtml },
  props: {
    brands: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedBrands: parseDataAttributeJson(this.brands),
      c: BRAND_CONSTANTS,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.BRANDS, {
      storeBrands: BRANDS_GETTERS.BRANDS,
    }),
    brandsWithLogoData() {
      return this.storeBrands.filter(brand => has(brand, BRAND_CONSTANTS.LOGO_DATA))
    },
  },
  created() {
    const allBrands = getDataArray(
      cloneDeep(
        get(
          this.parsedBrands,
          [API_CONSTANTS.RELATIONSHIPS, API_CONSTANTS.BRAND.TYPE, API_CONSTANTS.DATA],
          [],
        ),
      ),
    )

    this.setBrands(allBrands)
  },
  methods: {
    ...mapActions(STOREMODULES.BRANDS, {
      setBrands: BRANDS_ACTIONS.SET_BRANDS,
    }),
  },
}
</script>

<style lang="scss" module>
.brands {
  position: absolute !important;

  display: none;
  width: 1px;
  height: 1px;
  overflow: hidden;

  white-space: nowrap;

  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
}
</style>
